<template>
	<div id="uploadDocumentModalComponent">
		<button class="btn-link" data-toggle="modal" data-target=".upload-document-modal-component" ref="showUploadDocument" v-show="false">Show Upload Document</button>
		<button ref="btnGetUploadDocument" @click="showUploadDocumentLocal" v-show="false">Buscar Documentos Adjuntos</button>

		<div class="modal fade upload-document-modal-component" tabindex="1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Documentos Adjuntos - {{title}} {{id}}</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="row">
							<div class="col-4">
								<ul class="list-img">
									<li class="pointer" v-for="(item, index) in listUploadDocuments" :key="index"
										:class="(index == indexSelected) ? 'bg-info' : ''"
										@click="indexSelect(index)">
										{{item.uploadDocument.name_original}}
									</li>
								</ul>
								<div>
									<small>
										<label for="file-upload" class="subir float-end pointer" v-show="btnUpload">
											<i class="fas fa-cloud-upload-alt"></i> Subir archivo
										</label>
									</small>
									<input id="file-upload" @change='loadFile' type="file" style='display: none;' accept=".png, .jpg, .jpeg"/>
								</div>
							</div>
							<div class="col-8 text-center" v-if="indexSelected > -1">
								<a :href="src" target="_black" style="position:absolute; top: 0px; right: 10px;" title="Abrir en otra pestaña">
									<i class="fas fa-external-link-alt"></i>
								</a>
								<img :src="src" style="max-width: 100%; max-height: 600px;"/>
								<i class="far fa-trash-alt text-danger pointer" style="position:absolute; bottom: 0px; right: 10px;" @click="deleteUploadDocumentLocal()" v-show="btnDelete"></i>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeModal">Cerrar</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import errors from '@/mixins/errors.js'
	import axiosAction from '@/mixins/axiosAction.js'
	import uploadDocument from '@/mixins/generals/uploadDocument.js'

	export default {
		name: 'UploadDocumentModalComponent',
		mixins: [mixin, errors, axiosAction, uploadDocument],
		props: ['id', 'controller', 'configUploadDocumentId', 'btnDelete', 'btnUpload', 'title'],
		data () {
			return {
				indexSelected: -1
			}
		},
		computed: {
			src() {
				let img = ''
				if(this.listUploadDocuments.length > 0 && this.indexSelected > -1) {
					img = this.img = this.listUploadDocuments[this.indexSelected].uploadDocument.public_path + this.listUploadDocuments[this.indexSelected].uploadDocument.name_save
				}
				return img
			}
		},
		methods: {
            deleteUploadDocumentLocal() {
				let id = this.listUploadDocuments[this.indexSelected].id
                console.log('Elimando Documento Adjunto Nº ' + id)
				this.deleteUploadDocument(this.controller, this.id,  id)
            },
			deleteUploadDocumentResultLocal(response) {
				this.indexSelected = (this.listUploadDocuments.length > 0) ? 0 : -1
			},
			closeModal() {
				this.indexSelected = -1
			},
			getUploadDocumentByControllerResultLocal(response) {
				if(this.listUploadDocuments.length > 0) {
					this.indexSelected = 0
				}
			},
			indexSelect(index) {
				this.indexSelected = index
			},
			loadFile() {
                let file = event.target.files[0]
                let formData = new FormData();
                formData.append('file', file);
				formData.append('configUploadDocumentId', this.configUploadDocumentId);

				this.saveUploadDocument(this.controller, this.id, formData)
			},
			resultAxiosLocal(responseLocal, response) {
				this.$emit('hideLockScreen')
				switch(responseLocal) {
					case 'deleteUploadDocumentResult': this.deleteUploadDocumentResult(response); break;
					case 'getUploadDocumentByControllerResult': this.getUploadDocumentByControllerResult(response); break;
					case 'saveUploadDocumentResult': this.saveUploadDocumentResult(response); break;
					default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
				}
			},
			saveUploadDocumentResultLocal(response) { },
			showUploadDocumentLocal() {
				this.indexSelected = -1
				this.getUploadDocumentByController(this.id, this.controller)
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.list-img {
	li {
		padding: 5px 10px;
		border-bottom: 1px solid #ddd;
	}
}
</style>
